// app/routes/__root.tsx
import {
  createRootRoute,
  HeadContent,
  Outlet,
  redirect,
  Scripts,
} from "@tanstack/react-router";
import * as React from "react";
import { useAuthUser } from "@stores/UseAuth";

export const Route = createRootRoute({
  component: RootComponent,
  beforeLoad: async ({ location }) => {
    // Kiểm tra access_token trong localStorage
    const accessToken = localStorage.getItem("access_token");
    const isAuthenticated = !!accessToken;

    // Exclude các route public không cần auth
    const publicRoutes = ["/login", "/callback/login/zalo-web"];
    const isPublicRoute = publicRoutes.includes(location.pathname);

    // Nếu đang truy cập route private và chưa đăng nhập
    if (!isPublicRoute && !isAuthenticated) {
      throw redirect({
        to: "/login",
        replace: true,
      });
    }

    // Nếu đang truy cập /login và đã đăng nhập
    if (location.pathname === "/login" && isAuthenticated) {
      throw redirect({
        to: "/",
        replace: true,
      });
    }

    return {
      auth: {
        isAuthenticated,
        accessToken,
      },
    };
  },
});

function RootComponent() {
  return (
    <RootDocument>
      <Outlet />
    </RootDocument>
  );
}

function RootDocument({ children }: { children: React.ReactNode }) {
  return (
    <html>
      <head>
        <HeadContent />
      </head>
      <body>
        {children}
        <Scripts />
      </body>
    </html>
  );
}
